import classNames from "classnames";
import { Inter } from "next/font/google";
import { GlutenFreePlaceRecommendations } from "@/components/molecules/GlutenFreePlaceRecommendations";
import { TopPlaceDescription } from "@/components/atoms/TopPlaceDescription";
import { TopPlaceTags } from "@/components/molecules/TopPlaceTags";
import { GlutenFreeIdentity } from "@/components/molecules/GlutenFreeIdentity";
import { trackItemTapped } from "@/utils/mixpanel";
import { MixpanelValues } from "@/constants/mixpanel";

const inter = Inter({ subsets: ["latin"] });

export const TopPlaceInformation = ({
    title,
    address,
    recommendationsCount,
    tags,
    description,
    isMobile,
    gfIdentityData,
}) => {
    return (
        <div className="px-4 md:px-0 box-content border-b border-zinc-200 md:border-none text-blue-900">
            <h1
                onClick={() => trackItemTapped(MixpanelValues.ItemTapped.NAME)}
                className={classNames(inter.className, {
                    "text-2xl md:text-4x": true,
                    "w-full font-bold leading-7 md:leading-10": true,
                    // 'blur ml-3 select-none': isBlurred,
                })}>
                {title}
            </h1>
            <GlutenFreeIdentity
                lean
                data={gfIdentityData}
                isMobile={isMobile}
            />
            <p
                onClick={() => trackItemTapped(MixpanelValues.ItemTapped.ADDRESS)}
                className={classNames(inter.className, {
                    "text-[11px] md:text-lg font-normal md:font-medium leading-relaxed mb-2": true,
                    // 'blur ml-3 select-none': isBlurred,
                })}>
                {address}
            </p>
            <div className="flex gap-2 flex-col mb-4">
                <TopPlaceTags tags={tags}/>
                <TopPlaceDescription description={description}/>
                <GlutenFreePlaceRecommendations count={recommendationsCount}/>
            </div>
        </div>
    );
};
